import Snackbar from '@app/components/molecules/Snackbar';
import React, { createContext, useContext, useState } from 'react';
var SnackbarContext = /*#__PURE__*/createContext();

// eslint-disable-next-line react/prop-types
var SnackbarProvider = function SnackbarProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    snackbarOpen = _useState[0],
    setSnackbarOpen = _useState[1];
  var _useState2 = useState('success'),
    snackbarType = _useState2[0],
    setSnackbarType = _useState2[1];
  var _useState3 = useState(''),
    snackbarMessage = _useState3[0],
    setSnackbarMessage = _useState3[1];
  var showSnackbar = function showSnackbar() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'success';
    var message = arguments.length > 1 ? arguments[1] : undefined;
    setSnackbarOpen(true);
    if (message) {
      setSnackbarMessage(message);
    }
    setSnackbarType(type);
  };
  var hideSnackbar = function hideSnackbar() {
    setSnackbarMessage('');
    setSnackbarOpen(false);
  };
  return /*#__PURE__*/React.createElement(SnackbarContext.Provider, {
    value: {
      snackbarOpen: snackbarOpen,
      showSnackbar: showSnackbar,
      hideSnackbar: hideSnackbar,
      snackbarType: snackbarType,
      snackbarMessage: snackbarMessage
    }
  }, snackbarOpen && /*#__PURE__*/React.createElement(Snackbar, {
    type: snackbarType,
    open: snackbarOpen,
    message: snackbarMessage,
    close: snackbarType !== 'loading',
    autoHideDuration: 3000,
    onClose: hideSnackbar
  }), children);
};
export var useSnackbar = function useSnackbar() {
  return useContext(SnackbarContext);
};
export default SnackbarProvider;